import { render, staticRenderFns } from "./susCourse.vue?vue&type=template&id=5bbe1a50&"
import script from "./susCourse.vue?vue&type=script&lang=js&"
export * from "./susCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports